$(document).ready(function () {
    let element = $(".owl-carousel");
    if (element.owlCarousel)
        element.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            autoplay: true
        });
});